var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.invoiceValues, function(shipmentOrder) {
        return _c("div", [
          shipmentOrder
            ? _c(
                "div",
                { staticClass: "box sc-pre-invoice-detail-value__box" },
                [
                  _c("div", { staticClass: "columns is-multiline" }, [
                    _c("div", { staticClass: "column is-6 is-3-widescreen" }, [
                      _c("article", { staticClass: "panel" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "panel-heading has-text-primary has-text-weight-bold"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.getInvoiceLabel(shipmentOrder.invoice)
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "panel-block page-pre-invoice-detail__panel__block"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "columns page-pre-invoice-detail__cols"
                              },
                              [
                                _c("div", { staticClass: "column is-narrow" }, [
                                  _c(
                                    "h6",
                                    { staticClass: "has-text-weight-bold" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getInvoiceLabel(
                                              shipmentOrder.invoice
                                            )
                                          ) +
                                          ": "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    shipmentOrder && shipmentOrder.invoice
                                      ? _c("p", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getInvoiceIdentifier(
                                                  shipmentOrder.invoice
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "panel-block page-pre-invoice-detail__panel__block"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "columns page-pre-invoice-detail__cols"
                              },
                              [
                                _c("div", { staticClass: "column is-narrow" }, [
                                  _c(
                                    "h6",
                                    { staticClass: "has-text-weight-bold" },
                                    [
                                      _vm._v(
                                        "Valor " +
                                          _vm._s(
                                            _vm.getInvoiceLabel(
                                              shipmentOrder.invoice
                                            )
                                          ) +
                                          ": "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    shipmentOrder &&
                                    shipmentOrder.invoice &&
                                    shipmentOrder.invoice.value
                                      ? _c("p", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  shipmentOrder.invoice.value
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "panel-block page-pre-invoice-detail__panel__block"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "columns page-pre-invoice-detail__cols"
                              },
                              [
                                _vm._m(0, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            shipmentOrder.products_value
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "panel-block page-pre-invoice-detail__panel__block"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "columns page-pre-invoice-detail__cols"
                              },
                              [
                                _vm._m(1, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            shipmentOrder.total_value
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column is-6 is-3-widescreen" }, [
                      _c(
                        "article",
                        {
                          staticClass:
                            "panel sc-pre-invoice-detail-value__panel"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "panel-heading has-text-primary has-text-weight-bold"
                            },
                            [
                              _vm._v(
                                "\n              Documento de Transporte\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-block page-pre-invoice-detail__panel__block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns page-pre-invoice-detail__cols"
                                },
                                [
                                  _vm._m(2, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "column has-text-right" },
                                    [
                                      shipmentOrder.cte &&
                                      shipmentOrder.cte.number &&
                                      shipmentOrder.cte.serie
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  shipmentOrder.cte.number +
                                                    "-" +
                                                    shipmentOrder.cte.serie
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-block page-pre-invoice-detail__panel__block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns page-pre-invoice-detail__cols"
                                },
                                [
                                  _vm._m(3, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "column has-text-right" },
                                    [
                                      shipmentOrder.cte &&
                                      shipmentOrder.cte.company_name
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  shipmentOrder.cte.company_name
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-block page-pre-invoice-detail__panel__block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns page-pre-invoice-detail__cols"
                                },
                                [
                                  _vm._m(4, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "column has-text-right" },
                                    [
                                      shipmentOrder.cte &&
                                      shipmentOrder.cte.freight_value
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    shipmentOrder.cte
                                                      .freight_value
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column is-6 is-3-widescreen" }, [
                      _c(
                        "article",
                        {
                          staticClass:
                            "panel sc-pre-invoice-detail-value__panel"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "panel-heading has-text-primary has-text-weight-bold"
                            },
                            [
                              _vm._v(
                                "\n              Dados Complementares\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-block page-pre-invoice-detail__panel__block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns page-pre-invoice-detail__cols"
                                },
                                [
                                  _vm._m(5, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "column has-text-right" },
                                    [
                                      _c("p", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "/ng#/order-number/" +
                                                shipmentOrder.order_number
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  shipmentOrder.order_number
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-block page-pre-invoice-detail__panel__block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns page-pre-invoice-detail__cols"
                                },
                                [
                                  _vm._m(6, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "column has-text-right" },
                                    [
                                      shipmentOrder &&
                                      shipmentOrder.origin_zipcode
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cep")(
                                                    _vm.parseCEP(
                                                      shipmentOrder.origin_zipcode
                                                    )
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-block page-pre-invoice-detail__panel__block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns page-pre-invoice-detail__cols"
                                },
                                [
                                  _vm._m(7, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "column has-text-right" },
                                    [
                                      shipmentOrder &&
                                      shipmentOrder.destination_zipcode
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cep")(
                                                    _vm.parseCEP(
                                                      shipmentOrder.destination_zipcode
                                                    )
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column is-6 is-3-widescreen" }, [
                      _c(
                        "article",
                        {
                          staticClass:
                            "panel sc-pre-invoice-detail-value__panel sc-pre-invoice-detail-value__panel--volumes"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-heading has-text-primary has-text-weight-bold"
                            },
                            [
                              _c("p", [_vm._v("Volumes")]),
                              _vm._v(" "),
                              _c("small", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-text has-text-primary",
                                    attrs: {
                                      disabled:
                                        !shipmentOrder.volumes ||
                                        shipmentOrder.volumes.length === 0
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showAllVolumes(
                                          shipmentOrder.volumes
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Ver todos\n                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          [
                            shipmentOrder.volumes &&
                            shipmentOrder.volumes.length > 0
                              ? _c(
                                  "sc-tabs",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-detail-value__panel__tabs",
                                    attrs: { animated: false },
                                    model: {
                                      value: _vm.activeTab,
                                      callback: function($$v) {
                                        _vm.activeTab = $$v
                                      },
                                      expression: "activeTab"
                                    }
                                  },
                                  _vm._l(shipmentOrder.volumes, function(
                                    volume,
                                    index
                                  ) {
                                    return _c(
                                      "sc-tab-item",
                                      {
                                        key: index,
                                        staticClass:
                                          "page-pre-invoice-detail__panel__block vertical",
                                        attrs: {
                                          label: "Volume " + (index + 1)
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "columns page-pre-invoice-detail__cols"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "column is-narrow"
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Código de rastreio:"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "column has-text-right"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "http://status-testing.intelipost.com.br/tracking/" +
                                                        volume.tracking_code,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          volume.tracking_code
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "columns page-pre-invoice-detail__cols"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "column is-narrow"
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-bold"
                                                  },
                                                  [_vm._v("Peso:")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "column has-text-right"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(_vm._s(volume.weight))
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "columns page-pre-invoice-detail__cols"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "column is-narrow"
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-bold"
                                                  },
                                                  [_vm._v("Peso Cubado:")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "column has-text-right"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      volume.squared_weight
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "columns page-pre-invoice-detail__cols"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "column is-narrow"
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-bold"
                                                  },
                                                  [_vm._v("Peso Selecionado:")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "column has-text-right"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      volume.selected_weight
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "columns page-pre-invoice-detail__cols"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "column is-narrow"
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-bold"
                                                  },
                                                  [_vm._v("Dimensões:")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "column has-text-right"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.transformDimensions(
                                                        volume.dimensions
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                )
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-block page-pre-invoice-detail__panel__block"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columns page-pre-invoice-detail__cols"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "column is-narrow" },
                                            [
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "has-text-weight-bold"
                                                },
                                                [_vm._v("Peso:")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "column has-text-right"
                                            },
                                            [_c("p")]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-block page-pre-invoice-detail__panel__block"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columns page-pre-invoice-detail__cols"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "column is-narrow" },
                                            [
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "has-text-weight-bold"
                                                },
                                                [_vm._v("Peso Cubado:")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "column has-text-right"
                                            },
                                            [_c("p")]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-block page-pre-invoice-detail__panel__block"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columns page-pre-invoice-detail__cols"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "column is-narrow" },
                                            [
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "has-text-weight-bold"
                                                },
                                                [_vm._v("Peso Selecionado:")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "column has-text-right"
                                            },
                                            [_c("p")]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-block page-pre-invoice-detail__panel__block"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columns page-pre-invoice-detail__cols"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "column is-narrow" },
                                            [
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "has-text-weight-bold"
                                                },
                                                [_vm._v("Dimensões:")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "column has-text-right"
                                            },
                                            [_c("p")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                          ]
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box", staticStyle: { "margin-bottom": "2rem" } },
            [
              _c(
                "sc-table",
                {
                  staticClass: "sc-pre-invoice-detail-value__table",
                  attrs: {
                    data: shipmentOrder.taxes,
                    paginated: _vm.isPaginated(shipmentOrder.taxes),
                    "per-page": _vm.pagination.limit,
                    "row-class": function(row) {
                      return _vm.getClassByMarginStatus(row)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                label: "Taxa",
                                field: "name",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(row.name) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                label: "Tipo",
                                field: "type",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getTaxTypeEnum(row.type)) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                label: "Valor TMS",
                                field: "values.tms.value",
                                sortable: ""
                              }
                            },
                            [
                              !_vm.cteNotInformed(row) && _vm.isDifferent(row)
                                ? _c(
                                    "sc-tooltip",
                                    {
                                      attrs: {
                                        label:
                                          "Valores do TMS e do CTE não são iguais",
                                        type: "is-dark",
                                        dashed: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          class: _vm.getClassByDifference(row)
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  row.values.tms.value
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            row.values.tms.value
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                label: "TMS %",
                                field: "values.tms.percent",
                                sortable: ""
                              }
                            },
                            [
                              _vm.isDifferent(row, "percent")
                                ? _c(
                                    "sc-tooltip",
                                    {
                                      attrs: {
                                        label:
                                          "Porcentagens do TMS e do CTE não são iguais",
                                        type: "is-dark",
                                        dashed: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          class: _vm.getClassByDifference(
                                            row,
                                            "percent"
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(row.values.tms.percent) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(row.values.tms.percent) +
                                        "\n            "
                                    )
                                  ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                label: "Valor CTE",
                                field: "values.cte.value",
                                sortable: ""
                              }
                            },
                            [
                              _vm.cteNotInformed(row)
                                ? [
                                    _c("sc-icon", {
                                      attrs: {
                                        icon: "exclamation-triangle",
                                        size: "is-small",
                                        type: "is-warning"
                                      }
                                    }),
                                    _vm._v(" Valor não informado\n            ")
                                  ]
                                : !_vm.cteNotInformed(row) &&
                                  _vm.isDifferent(row)
                                ? _c(
                                    "sc-tooltip",
                                    {
                                      attrs: {
                                        label:
                                          "Valores do TMS e do CTE não são iguais",
                                        type: "is-dark",
                                        dashed: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          class: _vm.getClassByDifference(row)
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  row.values.cte.value
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            row.values.cte.value
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                label: "CTE %",
                                field: "values.cte.percent",
                                sortable: ""
                              }
                            },
                            [
                              _vm.isDifferent(row, "percent")
                                ? _c(
                                    "sc-tooltip",
                                    {
                                      attrs: {
                                        label:
                                          "Porcentagens do TMS e do CTE não são iguais",
                                        type: "is-dark",
                                        position: "is-left",
                                        dashed: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          class: _vm.getClassByDifference(
                                            row,
                                            "percent"
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(row.values.cte.percent) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(row.values.cte.percent) +
                                        "\n            "
                                    )
                                  ]
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { attrs: { slot: "empty" }, slot: "empty" },
                    [
                      _c("sc-table-empty", {
                        attrs: {
                          message: "Nenhuma informação de taxas encontrada"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ])
      }),
      _vm._v(" "),
      _c(
        "sc-modal",
        {
          attrs: { active: _vm.showVolumesModal },
          on: {
            "update:active": function($event) {
              _vm.showVolumesModal = $event
            }
          }
        },
        [
          _c(
            "sc-modal-card",
            { staticClass: "sc-pre-invoice-detail-value__modal" },
            [
              _c("template", { attrs: { slot: "title" }, slot: "title" }, [
                _c("h2", { staticClass: "modal-card-title" }, [
                  _vm._v("\n          Volumes\n        ")
                ])
              ]),
              _vm._v(" "),
              _c(
                "template",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("sc-pre-invoice-detail-volumes-table", {
                    attrs: { data: _vm.currentVolumesModal }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Valor dos produtos:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Valor Frete:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Número do Documento:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [_vm._v("Emissor:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Valor Frete:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("Número do Pedido:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [_vm._v("CEP Origem:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h6", { staticClass: "has-text-weight-bold" }, [
        _vm._v("CEP Destino:")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e806300e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e806300e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/ScPreInvoiceDetailValues.vue
// module id = null
// module chunks = 